import React from "react";
import styled from "styled-components";
import Link from "gatsby-link";
import Logo from "./Logo";
import { getThemeColor } from "../utils";
import Spacer from "./blocks/Spacer";
import Flex from "./blocks/Flex";
import facebookIcon from "../../assets/facebook-icon.png";
import twitterIcon from "../../assets/twitter-icon.png";

const OuterDiv = styled.div`
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: stretch;
  transition: opacity 300ms;
  opacity: ${props => (props.isVisible ? 1 : 0)};
  bottom: ${props => (props.isVisible ? 0 : "100%")};
  margin: 0;
  padding: 0;
  background-color: ${getThemeColor("purpleDark")};
`;

const InnerDiv = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 2.1rem 5rem;
  max-width: 72rem;
  width: 100%;
  height: 100vh;
  min-height: max-content;
  ${props => props.theme.media.mobile`
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding-right: 0;
  `};
`;

const Links = styled.div`
  font-size: 2rem;
  padding-top: .125rem;
  ${props => props.theme.media.mobile`
  width: 80%;
  `};
`;

const NavigationLink = styled(Link)`
  font-size: ${({ small }) => (small ? "1.1rem" : "2.0rem")};
  display: flex;
  justify-content: flex-end;
  padding-bottom: 1rem;
  color: ${getThemeColor("white")};
  text-decoration: none;
`;

const NavLink = props =>
  <Flex justify="flex-end">
    <NavigationLink {...props} />
  </Flex>;

const LogoSection = styled(NavigationLink)`
  padding-right: 2.3125rem;
  padding-bottom: 2rem;
  ${props => props.theme.media.mobile`
    padding: 0;
    padding-bottom: 3rem;
    width: 80%;
  `};
`;

const Social = () =>
  <Flex justify="flex-end" style={{ width: "100%" }}>
    <Flex justify="space-between" style={{ width: 100 }}>
      <a href="http://facebook.com/contralineinc">
        <img src={facebookIcon} style={{ height: 32 }} />
      </a>
      <a href="http://twitter.com/contraline">
        <img src={twitterIcon} style={{ height: 32 }} />
      </a>
    </Flex>
  </Flex>;

export default ({ isVisible = false, toggleMenuVisibility }) => {
  return (
    <OuterDiv isVisible={isVisible}>
      <InnerDiv onClick={toggleMenuVisibility}>
        <LogoSection to="/">
          <Logo color="white" />
        </LogoSection>
        <Links>
          <NavLink to="/product">Product</NavLink>
          <NavLink to="/trials#scroll-anchor">Trials</NavLink>
          <NavLink to="/mission">Mission</NavLink>
          <NavLink to="/team">Team</NavLink>
          <NavLink to="/careers">Careers</NavLink>
          <NavLink to="/news">News</NavLink>
          <NavLink to="/contact">Contact</NavLink>
          <NavLink to="/participate">Participate</NavLink>
          <Spacer span={1} />
          <Social />
        </Links>
      </InnerDiv>
    </OuterDiv>
  );
};



// WEBPACK FOOTER //
// ./src/components/NavMenu.js